$(function() {
  const $menus = $(".js-menu-only-present");
  $menus.find("a[href^='#']")
    .filter(function () {
      const href = this.getAttribute("href");
      return href !== "#" && !$(href).length;
    })
    .closest("li")
    .addClass("d-none");
  $menus.removeClass("d-none");
});